import type { KanbanLog } from '@ts-kanban-logs/interfaces'
import type { Pagination } from '@ts-common/interfaces'

import { useTutorKanbanStore } from '@stores/tutor-kanban'
import { useCommonStore } from '@stores/common'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface LogsApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: (data: KanbanLog[]) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

interface LogsApiResponse {
  logs: KanbanLog[]
  meta: Pagination
}

export const useLogsApi = async (options: LogsApiOptions): Promise<KanbanLog[]> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.logs', { tutor_id: options.tutorId })

  const tutorKanbanStore = useTutorKanbanStore()
  const commonStore = useCommonStore()

  options.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: LogsApiResponse = data.data

    tutorKanbanStore.setLogs(response.logs)
    tutorKanbanStore.setLogsPagination(response.meta)
    commonStore.setLoading(false)

    options.onSuccess?.(response.logs)

    return response.logs
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options.onError?.(err)

    return []
  } finally {
    options.onFinish?.()
  }
}
